import { formatPdpCarat } from './formatPdpCarat';

interface ProductShortDescriptionLineInput {
  shortDesc: string | null;
  metalWeight: number;
  diamondCarat: number | null;
}

/**
 * Mirrors legacy PDP copy: "{shortDesc} ({weight} gram) with Diamonds ({carat} Ct)".
 * Weight and diamond suffixes are appended after API data is available.
 */
export function formatProductShortDescriptionLine({
  shortDesc,
  metalWeight,
  diamondCarat,
}: ProductShortDescriptionLineInput): string | null {
  if (!shortDesc) return null;

  let line = shortDesc;

  if (metalWeight > 0) {
    line += ` (${metalWeight} grams)`;
  }

  if (diamondCarat) {
    line += ` with Diamonds (${formatPdpCarat(diamondCarat)} Ct)`;
  }

  return line;
}

export function getEffectiveShortDesc(
  shortDesc: string | null,
  customizationShortDesc: string | null | undefined
): string | null {
  return customizationShortDesc ?? shortDesc;
}
